var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"miniDash"},[_c('horizontal-bar-chart',{staticClass:"chart",attrs:{"chart-data":_vm.lineChart,"options":_vm.lineChartOptions,"width":200,"height":200}}),(
      _vm.isFullAdmin ||
      (_vm.config.verPontosObtidos && _vm.groupsConfig.verPontosObtidos)
    )?_c('div',{staticClass:"pontosObtidos"},[_c('div',{staticClass:"title"},[_vm._v("Pontos Obtidos")]),_c('div',{staticClass:"valor"},[_vm._v("\n      "+_vm._s(_vm.miniDash.length && _vm.miniDash[0].pontosObtidos)+"\n    ")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }